module.exports = __webpack_public_path__ + "assets/70fb4e1787f93083c2995e17ad87ecc3.png";